/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Group_Options_Convert_SuccessInputs */

const en_event_group_options_convert_success = /** @type {(inputs: Event_Group_Options_Convert_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Event group has been converted to subtitles.`)
};

const fr_event_group_options_convert_success = /** @type {(inputs: Event_Group_Options_Convert_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le groupe d'événements a été converti en sous-titres.`)
};

const de_event_group_options_convert_success = /** @type {(inputs: Event_Group_Options_Convert_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Ereignisgruppe wurde in Untertitel umgewandelt.`)
};

const it_event_group_options_convert_success = /** @type {(inputs: Event_Group_Options_Convert_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il gruppo di eventi è stato convertito in sottotitoli.`)
};

const ru_event_group_options_convert_success = /** @type {(inputs: Event_Group_Options_Convert_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Группа событий преобразована в субтитры.`)
};

const es_event_group_options_convert_success = /** @type {(inputs: Event_Group_Options_Convert_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El grupo de eventos se ha convertido a subtítulos.`)
};

const zh_cn2_event_group_options_convert_success = /** @type {(inputs: Event_Group_Options_Convert_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`事件组已转换为字幕。`)
};

const ja_event_group_options_convert_success = /** @type {(inputs: Event_Group_Options_Convert_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベントグループが字幕に変換されました。`)
};

const hi_event_group_options_convert_success = /** @type {(inputs: Event_Group_Options_Convert_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इवेंट समूह को उपशीर्षकों में परिवर्तित कर दिया गया है।`)
};

const pt_pt2_event_group_options_convert_success = /** @type {(inputs: Event_Group_Options_Convert_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O grupo de eventos foi convertido em legendas.`)
};

/**
* | output |
* | --- |
* | "Event group has been converted to subtitles." |
*
* @param {Event_Group_Options_Convert_SuccessInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_group_options_convert_success = /** @type {((inputs?: Event_Group_Options_Convert_SuccessInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Group_Options_Convert_SuccessInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_event_group_options_convert_success(inputs)
	if (locale === "de") return de_event_group_options_convert_success(inputs)
	if (locale === "it") return it_event_group_options_convert_success(inputs)
	if (locale === "ru") return ru_event_group_options_convert_success(inputs)
	if (locale === "es") return es_event_group_options_convert_success(inputs)
	if (locale === "zh-CN") return zh_cn2_event_group_options_convert_success(inputs)
	if (locale === "ja") return ja_event_group_options_convert_success(inputs)
	if (locale === "hi") return hi_event_group_options_convert_success(inputs)
	if (locale === "pt-PT") return pt_pt2_event_group_options_convert_success(inputs)
	return en_event_group_options_convert_success(inputs)
});